import React from 'react'
import { Carousel } from "react-bootstrap"
import "react-multi-carousel/lib/styles.css";

function FooterCarousel() {
    return (
        <div>
        <Carousel>
            <Carousel.Item>
            <div style={{backgroundColor:"#CC9D33",textAlign: "center", padding: "10% 10%",height: "20vh",}}>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>"I arrived in Cabo the day of my birthday, I was wearing a crazy hat because of that, suddenly the driver started to sing the Mexican version of HBD in Spanish to me! Priceless."</p>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}> Olivia, from USA. </p>
            </div>
                <Carousel.Caption>
                    
                </Carousel.Caption>

            </Carousel.Item>

            <Carousel.Item>
            <div style={{backgroundColor:"#CC9D33",textAlign: "center", padding: "10% 10%",height: "20vh",}}>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>"Prices are low, new Subs and the service beyond belief!!!! I recommend it!w, new Subs and the service beyond belief!!!! I recommend it!"</p>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}> Jason, from USA. </p>
            </div>

                <Carousel.Caption>
                    
                </Carousel.Caption>

            </Carousel.Item>

            <Carousel.Item>
            <div style={{backgroundColor:"#CC9D33",textAlign: "center", padding: "10% 10%",height: "20vh",}}>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>"So happy to travel with cabo travel solutions, the driver was so funny LOL, he recommended us the best places to visit in Cabo."</p>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>David S., from USA. </p>
            </div>
            </Carousel.Item>

            <Carousel.Item>
            <div style={{backgroundColor:"#CC9D33",textAlign: "center", padding: "10% 10%",height: "20vh",}}>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>"This company has a 100 in punctuality & Great Service! Cheers!."</p>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>Alfie, from USA. </p>
            </div>

                <Carousel.Caption>
                    
                </Carousel.Caption>

            </Carousel.Item>       

            <Carousel.Item>
            <div style={{backgroundColor:"#CC9D33",textAlign: "center", padding: "10% 10%",height: "20vh",}}>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>"I forgot my cellphone in one of their Suvs, I call to the management and they sent me my cellphone with one driver, I was so happy !!!!!!!!!!!!! Thanks Cabo Travel Solutions for your honestly."</p>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>Doreen, from USA. </p>
            </div>


                <Carousel.Caption>
                    
                </Carousel.Caption>

            </Carousel.Item>   

            <Carousel.Item>
            <div style={{backgroundColor:"#CC9D33",textAlign: "center", padding: "10% 10%",height: "20vh",}}>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>"Amazing Services."</p>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>J. Collins, from USA. </p>
            </div>


                <Carousel.Caption>
                    
                </Carousel.Caption>

            </Carousel.Item> 

            <Carousel.Item>
            <div style={{backgroundColor:"#CC9D33",textAlign: "center", padding: "10% 10%",height: "20vh",}}>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>"They were always careful with our luggage."</p>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>A. Fergurson, from USA. </p>
            </div>
            </Carousel.Item>  

            <Carousel.Item>
            <div style={{backgroundColor:"#CC9D33",textAlign: "center", padding: "10% 10%",height: "20vh",}}>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>"Their staff was always in great mood, they love to converse and suggest places to visit."</p>
            <p style={{color:"white",fontFamily: "Verdana, sans-serif", fontSize:"small",}}>Frank W., from USA. </p>
            </div>
            </Carousel.Item>  




        </Carousel> 
</div>
    )
}

export default FooterCarousel
